import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhx7cxb8wg: FaireProductEntity = {
  token: "p_hhx7cxb8wg",
  type: "product",
  name: "Soul Eater, Vol. 18",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2356233f723e9e57730fb39f0bba6e24a6bb5e05c06f7e9e5947c33ffb86d200.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "As Kid struggles against the madness deep in the Book of Eibon, a group of Spartoi members race to rescue their friend. Through page after page of Lust, Gluttony, and Envy, the students must conquer the seduction of their own fears and desires to reach the final chapter! Will their efforts be enough to give this tale a happy ending?",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:20.140Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
